import {Component} from 'lowkey-component'
import Swiper, {FreeMode, Scrollbar} from 'swiper'

type Ref = {
  image: Component<HTMLImageElement> | undefined;
}

export class ScrollableImage extends Component<HTMLDivElement, Ref> {

  private swiper: Swiper | null = null
  private slides: HTMLDivElement[] = []

  constructor(element: HTMLDivElement) {
    super(element)
    this.refs = {
      image: undefined
    }
  }

  didMount() {
    this.slides = Array.from(this.element.querySelectorAll('.swiper-slide'))
    this.slides.map((slide, index) => {
      const isFirst = index === 0
      if (isFirst) {
        const image = this.refs.image?.element
        const {width = 0} = image?.getBoundingClientRect() || {}
        slide.style.width = `${width}px`
      } else {
        slide.style.width = '1px'
      }
    })

    this.swiper = new Swiper(this.element, {
      modules: [FreeMode, Scrollbar],
      direction: 'horizontal',
      slidesPerView: 'auto',
      freeMode: {
        enabled: true,
        sticky: false,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
  }

  didUnmount() {
    this.swiper?.destroy()
  }
}
